import { useEffect, useState } from 'react'
import axios from 'axios'
//COMPONENTES PARTES


//INPORTAÇOES DE ICONES E IMAGENS
import IconChecked from '../../acets/img_icon/checked.svg'


import MenuPainelAdmin from '../partils/AdminMenuPainel'
import IconNoChecked from '../../acets/img_icon/nochecked.svg'
import IconEdit from '../../acets/img_icon/edit.svg'
import AdminHeader from '../partils/AdminHeader'

export default function AdminLead(){
    //CONGIGURAÇÕES=============================
    const config={
        pageName:'Leads',
        mainstring:'nome',
        url:'/api/leads/',
        url2:'',
        search:'/api/leads/search/',
        //urlOptions1:'/api/produtocategoria',
        params:'',
        messegerError:'ATENÇÃO - Preencha os campos para salvar os dados ;D',
    }
     //INICIANDO CICLO DE ESTADOS
     useEffect(()=>{
        rec();
        // eslint-disable-next-line react-hooks/exhaustive-deps
        },[])
    //STATES======================================
    ////    id_leads nome	telefone  email	porte	createdAt	updatedAt	
    const initialValues={ // DEFININDO UMA CONST PARA O STATE INICIAL 
        nome: '',telefone:'', email: '',porte: ''
    }
    const [openNew,setOpenNew]=useState(false)// ABRIR TELA DE CADASTRAR E EDITAR
    const [values, setValues]=useState(initialValues) // INICIANDO UM STATE
    const [data, setData] = useState([])
    //const[dataInput,setDataInput]=useState([{"id_produto_categoria":0}])
    //FUNÇÕES=====================================
    function rec() {//CARREGAR ESTADOS E ATUALIZAR CICLO DE COMPONENTES
        axios.get(config.url).then(resp=>{
            setData(resp.data)})
        
    }
    //console.log(data)
    function onChange(ev) {//ALTERAR OS STATES DOS INPUTS
        const {name, value} = ev.target; //ESTRAIR O NAME E VALUE DO EV
        setValues({ ...values, [name]:value }); //SETANDO O VALUE EM NAME
    }
    
    const exclui = function(id){//EXCLUI
        axios.delete(config.url + id).then(()=>{
            rec();
            
        })
    }
    function onSubmitSearch(ev){//PESQUISA
        ev.preventDefault();
        axios.post(config.search, values).then(respp=>{
            setData(respp.data)       
        })
    }
    //COMPONENTES DE LOOP==============================
    //    id_leads nome	telefone  email	porte	createdAt	updatedAt	
    const final = data.map(
        namesString =>
            <div className='w100 h4 row ma5 between linha'  key={namesString.id}> 
                <div className='w5'><img src={IconChecked}/><img/></div>
                <div className='w5 cell-tamanho10'>{namesString.id_produto}</div>
                <div className='w15 cell-tamanho80 fb'>{namesString.nome}</div>
                <div className='w10 cell-tamanho80 cell-margin5 c4'>{namesString.telefone}</div>
                <div className='w10 cell-tamanho80 cell-texto-p c4'>{namesString.email}</div>
                <div className='w10 cell-tamanho80 cell-texto-p c4 pcb10'>{namesString.porte==11
                ?'Ebook':'Site'}</div>
                <div className='w10  cell-tamanho80 cell-texto-p c4'>{namesString.createdAt}</div>
                <button className='w10 btn04 ' onClick={()=>exclui(namesString.id)}>X</button>
                
            </div>
    )
    
    return(
        <>
         <section className='h100 row between b31'>
            
            <MenuPainelAdmin/>
            <div className="h100 w80 cell-tamanho row center celular">
                    
                    <div className="w90 row between cell-tamanho celular">
                        <div className="h100 w100 cont-circ3  column cell-tamanho90 cell-paddingcb10">
                        <h5 className='w90'>Pesquisar {config.pageName}</h5>
                        <form className=' w90 row center' onSubmit={onSubmitSearch} autoComplete='off'>
                            <div className='w80'>
                                <input type="text" name="nome" onChange={onChange}/>
                            </div>
                            <div className='w20'>
                                <input type="submit" value="Pesquisar"/>
                            </div>
                        </form>
                        <div className='w90 h20 column'>
                            <label className='w100 ma5 fs1p3em'>{config.pageName} Listados(a)</label>
                            <div className='row between w100 h5 cell-none'>
                                <div className='w5 fs08em fb'>St:</div>
                                <div className='w5 fs08em fb'>ID</div>
                                <div className='w15 fs08em fb'>Nome:</div>
                                <div className='w10 fs08em fb'>Ingredientes:</div>
                                <div className='w10 fs08em fb'>Qnt:</div>
                                <div className='w10 fs08em fb'>Preco Custo:</div>
                                <div className='w10 fs08em fb'>Preco Final:</div>
                                <div className='w10 fs08em fb'>Lucro:</div>
                                <div className='w5 fs08em fb'>Cat:</div>
                                <div className='w10 fs08em fb'>Validade:</div>
                                <div className='w5 fs08em fb'>Editar</div>
                            </div>
                            {final}
                        </div>     
                    </div>
                </div>
            </div>
            
        </section>
      </>
    )
}

